 
 <div class="video-container">
            <video *ngIf="src" controls>
                <source [src]="src">
            </video>
 </div>
